import React from 'react';
import styles from './style.module.scss';
import { formatRelative } from 'date-fns';
import { pl } from 'date-fns/locale';
import clsx from 'clsx';

const formatDate = (dateString) => {
  try {
    const date = new Date(dateString);
    return formatRelative(date, new Date(), { locale: pl });
  } catch (error) {
    return dateString;
  }
};

const SingleComment = ({ comment }) => {
  const authorName = comment?.author?.node?.name || 'Gość';
  const avatarUrl = comment?.author?.node?.avatar?.url || '';
  const content = comment?.content || '';
  const date = comment?.date ? formatDate(comment.date) : '';
  const initial = authorName.charAt(0).toUpperCase();

  return (
    <div className={clsx(styles.commentContainer, 'px-0')}>
      <div className="flex items-start gap-3 px-0">
        {/* Zamiennik MUI Avatar */}
        <div
          className={clsx(
            styles.commentAvatar,
            'relative flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#333333] text-white px-0',
          )}
        >
          {avatarUrl ? (
            <img src={avatarUrl} alt={authorName} className="h-full w-full object-cover px-0" />
          ) : (
            <span className="text-[1.25rem] font-medium px-0">{initial}</span>
          )}
        </div>

        {/* Zawartość komentarza */}
        <div className="flex w-full flex-col px-0">
          <div className={clsx(styles.commentHeader, 'px-0')}>
            <span className={clsx(styles.commentAuthor, 'px-0')}>{authorName}</span>
            <span className={clsx(styles.commentDate, 'px-0')}>{date}</span>
          </div>

          <div className={clsx(styles.commentContent, 'px-0')} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      </div>
    </div>
  );
};

export default SingleComment;
